// 注入组件到全局中
import Bydownload from './download/Bydownload.vue';


export default {
  install(Vue) {
    Vue.component('Bydownload', Bydownload);

  }
}